/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const TaskStatusDto = {
    New: 'NEW',
    InProgress: 'IN_PROGRESS',
    Canceled: 'CANCELED',
    Done: 'DONE',
    Rejected: 'REJECTED',
    DoneNotConfirmed: 'DONE_NOT_CONFIRMED',
    Postponed: 'POSTPONED',
} as const;

export type TaskStatusDto = typeof TaskStatusDto[keyof typeof TaskStatusDto];



